//types
export const ADDITIONAL_FIELD_TYPE_TEXT = 0;
export const ADDITIONAL_FIELD_TYPE_TAGS = 1;
export const ADDITIONAL_FIELD_TYPE_SWITCH = 2;
export const ADDITIONAL_FIELD_TYPE_COUNTER = 3;
export const ADDITIONAL_FIELD_TYPE_SELECT = 4;
export const ADDITIONAL_FIELD_TYPE_MULTISELECT = 5;

// presentations
export const ADDITIONAL_FIELD_SELECT_PRESENTATION = 'select';
